import React from 'react'
import './CategoryIcon.css'

const CategoryIcon = ({ category, name }) => (
  <div className={`CategoryIcon ${category}`}><i className={`icon ${name}`}></i></div>
)

export default CategoryIcon